import palette from '../palette';

export default {
  root: {
    colors: palette.link,
  }
};
